import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#68c7ff",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 5.42238V4.56317",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.29119 5.42224H7.54442C7.27633 5.42193 7.01651 5.51504 6.80965 5.68556C6.60279 5.85609 6.46181 6.09336 6.41095 6.35658C6.3601 6.61979 6.40255 6.89251 6.53101 7.12781C6.65947 7.36312 6.8659 7.54631 7.11481 7.64588L8.88736 8.35473C9.13572 8.45466 9.34156 8.63789 9.46959 8.87299C9.59762 9.10809 9.63986 9.38042 9.58906 9.64326C9.53826 9.90609 9.39759 10.1431 9.19117 10.3135C8.98476 10.484 8.72546 10.5773 8.45776 10.5775H6.71356",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 11.4368V10.5776",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIncome;
